import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store/type';
import {Toast, ToastInitState} from '@/store/toast/toast.types';


export const ToastAction: ActionTree<ToastInitState, RootState> = {
  async _Toast({commit}: ActionContext<ToastInitState, RootState>, payload: Toast): Promise<void> {
    try {
      commit('notifyToast', payload);
    } catch (e) {
    }
  },

};
